<template lang="pug">
  div
    div(class="container" :inert="isDetailRoute ? true : null")
      div(class="bg-white px-3 px-md-4 px-xl-5 pb-5 pt-md-4 pt-xl-4")
        div(class="d-flex justify-content-between pt-xl-3 pb-5")
          div(class="fs-24 font-weight-bold text-left pr-2") 東震月刊
          div(class='d-none d-md-flex align-items-center')
              Icon(class="mr-1" pattern="FormatSize" size="24")
              button(class="btn-30 font-icon rounded-left border border-light border-right-0 bg-white p-0 focus-none" @click="setFontSize('+')")
                Icon(class="" pattern="Add" size="24")
              button(class="btn-30 font-icon rounded-right border border-light border-right-0 bg-white p-0 focus-none" @click="setFontSize('-')")
                Icon(class="" pattern="Remove" size="24")
        div(class="px-md-5")
          div(class="monthly d-flex flex-wrap")
            div(class="d-flex px-3 flex-column align-items-center col-12 col-sm-6 col-md-4 col-xl-3" :style="{fontSize: global.fontSize + 'px'}" style="margin-bottom:80px" v-for="item in monthly" :key="item.id")
              router-link(:to="'/sound/monthly/'+item.id")
                img(class="bg-dark mb-4 img-fluid" :src="(item.image_variants || {}).cover || item.image" loading="lazy")
                div(class="text-center text-dark") {{ item.title }}
                div(class="text-center text-secondary") {{ dayFormat(item.date,"YYYY-MM") }}
    router-view
</template>

<script>
import dayjs from 'dayjs'
import { getBossEbooks } from '@/api/sound'
import { mapState, mapMutations } from 'vuex'
import monthlyPolling from '@/mixins/monthly-polling'

const ModelName = 'Ebooks'

export default {
  name: 'Monthly',
  mixins: [monthlyPolling],
  data () {
    return {
      monthly: []
    }
  },
  mounted () {
    if (this.isDetailRoute) getBossEbooks().then(res => { this.monthly = res.data }).catch(() => {})
  },
  computed: {
    ...mapState({
      global: state => state.global,
      listModel: state => state.model[ModelName]
    }),
    isDetailRoute () {
      return this.$route.name === 'MonthlyDetail'
    }
  },
  methods: {
    ...mapMutations(['setFontSize']),
    dayFormat (time, format) {
      if (time) {
        return dayjs(time).format(format)
      }
      return ''
    }
  }
}
</script>

<style scoped>
@media (max-width:768px){
  .container {
    padding: 0;
    margin: 0;
    max-width: none;
  }
}
</style>
